// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ej6at","col":"styles_col__1Y79Q"};